import React, { useState } from "react";
import recurso_33 from "../assets/recurso_33.png";
import fondosP841 from "../assets/fondos_p84_1.png";
import fondosP842 from "../assets/fondos_p84_2.png";
import fondosP843 from "../assets/fondos_p84_3.png";
import wrapAround1 from "../assets/wrap_around_1.png";
import wrapAround2 from "../assets/wrap_around_2.png";
import recurso_36 from "../assets/recurso_36.png";
import recurso_37 from "../assets/recurso_37.png";
import recurso_38 from "../assets/recurso_38.png";
import recurso_39 from "../assets/recurso_39.png";
import recurso_40 from "../assets/recurso_40.png";
import recurso_41 from "../assets/recurso_41.png";

const Productos = () => {
  const [activeComponent, setActiveComponent] = useState("Corrugado");
  const [selectedSubButton, setSelectedSubButton] = useState(
    "Cajas con Aletas Divicajas"
  );

  const handleComponentChange = (component) => {
    setActiveComponent(component);
    if (component === "Cajas") setSelectedSubButton("Cajas con Aletas Divicajas");
  };

  const handleSubButtonClick = (button) => setSelectedSubButton(button);

  const renderContent = () => {
    const content = contentMap[activeComponent];
    switch (activeComponent) {
      case "Corrugado":
        return (
          <CorrugadoSection
            content={content}
            selectedSubButton={selectedSubButton}
            handleSubButtonClick={handleSubButtonClick}
          />
        );
      case "Cajas":
        return (
          <CajasSection
            content={content}
            selectedSubButton={selectedSubButton}
            handleSubButtonClick={handleSubButtonClick}
          />
        );
      case "Accesorios":
        return (
          <AccesoriosSection
            content={content}
            selectedSubButton={selectedSubButton}
            handleSubButtonClick={handleSubButtonClick}
          />
        );
      default:
        return null;
    }
  };

  return (
    <>
      <section
        id="productos"
        className="bg-[#3A3A3C] py-14 sm:py-32 w-full rounded-r-[4rem] sm:rounded-r-[10rem]"
      >
        <div className="container mx-auto px-4">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-8">
            <div className="lg:col-start-2 lg:col-span-10 flex items-center gap-4" data-scroll-reveal>
              <div className="relative flex items-center justify-center w-14 h-14 bg-[#31BBE4] rounded-2xl">
                <span className="text-[#3A3A3C] text-3xl font-light font-gotham">
                  P
                </span>
              </div>
              <div className="sm:col-start-10 sm:col-span-8 flex items-center space-x-4">
                <h2 className="text-xl font-noto text-white">Productos</h2>
              </div>
            </div>
            <div className="lg:col-start-2 lg:col-span-5 grid grid-cols-3 gap-3 sm:gap-4 items-center" data-scroll-reveal data-scroll-reveal-delay="80ms">
              <button
                className={`w-full h-24 lg:h-32 border text-xs sm:text-base px-2 ${
                  activeComponent === "Corrugado"
                    ? "border-[#B89A6E] text-[#B89A6E]"
                    : "border-white text-white"
                } bg-transparent hover:bg-white/5 transition-colors font-bold rounded-xl`}
                aria-pressed={activeComponent === "Corrugado"}
                onClick={() => handleComponentChange("Corrugado")}
              >
                Corrugado
              </button>
              <button
                className={`w-full h-24 lg:h-32 border text-xs sm:text-base px-2 ${
                  activeComponent === "Cajas"
                    ? "border-[#B89A6E] text-[#B89A6E]"
                    : "border-white text-white"
                } bg-transparent hover:bg-white/5 transition-colors font-bold rounded-xl`}
                aria-pressed={activeComponent === "Cajas"}
                onClick={() => handleComponentChange("Cajas")}
              >
                Cajas de Cartón
              </button>
              <button
                className={`w-full h-24 lg:h-32 border text-xs sm:text-base px-2 ${
                  activeComponent === "Accesorios"
                    ? "border-[#B89A6E] text-[#B89A6E]"
                    : "border-white text-white"
                } bg-transparent hover:bg-white/5 transition-colors font-bold rounded-xl`}
                aria-pressed={activeComponent === "Accesorios"}
                onClick={() => handleComponentChange("Accesorios")}
              >
                Accesorios
              </button>
            </div>
            <div className="lg:col-start-8 lg:col-span-4 min-w-0 flex items-center" data-scroll-reveal data-scroll-reveal-delay="140ms">
              <h2 className="text-3xl xl:text-4xl 2xl:text-5xl font-bold font-gotham leading-tight text-white w-full break-words">
                Cajas de Cartón Corrugado y Complementos
              </h2>
            </div>
          </div>
        </div>
      </section>
      <div
        key={activeComponent}
        className="animate-fade-up"
      >
        {renderContent()}
      </div>
    </>
  );
};

// Reemplazamos el contenido con la lógica de la transición de opacidad
const CajasSection = ({
  content,
  selectedSubButton,
  handleSubButtonClick,
}) => (
  <div
    className={`container mx-auto bg-[#F9F9F9] pt-12 pb-10 rounded-b-[4rem] sm:rounded-b-none`}
  >
    <div className="grid grid-cols-1 sm:grid-cols-12 gap-4 ">
      <div className="col-span-1 sm:col-start-2 sm:col-span-8 flex items-center space-x-4 font-bold font-gotham" data-scroll-reveal>
        <h2 className="text-2xl sm:text-3xl flex items-center font-gotham font-bold text-[#3A3A3C] px-4">
          {content.sections[selectedSubButton]?.title || content.title}
        </h2>
      </div>
      <div className="col-span-1 sm:col-start-2 sm:col-span-5" data-scroll-reveal data-scroll-reveal-delay="80ms">
        <p className="text-base leading-relaxed font-noto px-4">
          {content.sections[selectedSubButton]?.text || content.text}
        </p>
      </div>
      <div className="col-span-1 sm:col-start-2 sm:col-span-10 mt-4" data-scroll-reveal data-scroll-reveal-delay="120ms">
        <div className="grid grid-cols-1 gap-2.5 px-4 sm:grid-cols-2 lg:grid-cols-4 lg:gap-4 lg:px-0">
          {content.buttons.map((btn, index) => (
            <button
              key={index}
              className={`min-h-12 border font-gotham font-medium rounded-2xl px-4 py-3 text-sm leading-tight transition-all duration-300 ease-in-out ${
                selectedSubButton === btn
                  ? "border-[#B89A6E] text-[#80623A] bg-white shadow-[0_8px_18px_rgba(184,154,110,0.18)]"
                  : "border-gray-300 text-gray-500 bg-white/70 hover:border-[#B89A6E] hover:text-[#B89A6E]"
              }`}
              aria-pressed={selectedSubButton === btn}
              onClick={() => handleSubButtonClick(btn)}
            >
              {btn}
            </button>
          ))}
        </div>
      </div>
      <div key={selectedSubButton} className={`animate-fade-up col-span-1 mt-3 ${content.sections[selectedSubButton] ? "sm:col-start-2 sm:col-span-10 flex flex-col sm:flex-row items-center justify-center gap-6 px-4 pt-6" : "sm:col-start-3 sm:col-span-8"}`}>
        {content.sections[selectedSubButton] ? (
          content.sections[selectedSubButton].images.map((src, index) => (
            <div key={src} className="w-full min-w-0 flex-1">
              <img
                src={src}
                alt={`${selectedSubButton} - modelo ${index + 1}`}
                className="w-full h-56 lg:h-72 object-contain mx-auto"
              />
            </div>
          ))
        ) : selectedSubButton && (
          <img
            src={content.images[selectedSubButton]}
            alt={selectedSubButton}
            className="transition-opacity duration-500 ease-in-out w-full sm:w-auto mx-auto"
          />
        )}
      </div>
    </div>
  </div>
);

const AccesoriosSection = ({ content }) => (
  <div
    className={`container mx-auto bg-[#F9F9F9] pt-12 pb-10 rounded-b-[4rem] sm:rounded-b-none`}
  >
    <div className="grid grid-cols-1 sm:grid-cols-12 gap-4">
      <div className="col-span-1 sm:col-start-2 sm:col-span-8 flex items-center space-x-4 font-bold font-gotham" data-scroll-reveal>
        <h2 className="text-2xl sm:text-3xl flex items-center font-noto text-[#3A3A3C] px-4">
          {content.title}
        </h2>
      </div>
      <div className="col-span-1 sm:col-start-2 sm:col-span-10 mt-3 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6" data-scroll-reveal data-scroll-reveal-delay="100ms">
        {content.sections.map((section, index) => (
          <div key={index} className="flex flex-col bg-[#F5F5F5] p-4">
            <img
              src={section.image}
              alt={section.name}
              className="transition-opacity duration-500 ease-in-out w-full sm:w-auto mx-auto"
            />
            <p className="text-[#B89A6E] font-gotham font-medium text-lg mt-2">
              {section.name}
            </p>
            <p className="text-[#3A3A3C] font-gotham font-medium text-md mt-2">
              {section.description}
            </p>
          </div>
        ))}
      </div>
    </div>
  </div>
);

const CorrugadoSection = ({
  content,
  selectedSubButton,
  handleSubButtonClick,
}) => (
  <div
    className={`p-4 container mx-auto bg-[#F9F9F9] pt-12 pb-10 rounded-b-[4rem] sm:rounded-b-none`}
  >
    <div className="grid grid-cols-1 sm:grid-cols-12 gap-4">
      <div className="col-span-1 sm:col-start-2 sm:col-span-8 flex items-center space-x-4 font-bold font-gotham" data-scroll-reveal>
        <h2 className="text-2xl sm:text-3xl flex items-center font-gotham font-bold text-[#3A3A3C] px-4">
          {content.title}
        </h2>
      </div>
      <div className="col-span-1 sm:col-start-2 sm:col-span-4 mt-3" data-scroll-reveal data-scroll-reveal-delay="80ms">
        <p className="text-base leading-relaxed font-noto px-4">{content.text}</p>
      </div>
      <div className="col-span-1 sm:col-start-8 sm:col-span-4 flex justify-center sm:justify-center" data-scroll-reveal data-scroll-reveal-delay="140ms">
        <img
          src={content.image}
          alt={content.title}
          className="transition-opacity duration-500 ease-in-out w-full max-w-sm sm:max-w-md lg:max-w-[460px] xl:max-w-[500px] h-auto object-contain"
        />
      </div>
    </div>
  </div>
);

const contentMap = {
  Corrugado: {
    title: "Corrugado",
    text: "El cartón corrugado es utilizado para la fabricación de embalajes de casi todos los productos, por ello existen distintos tipos de materiales y resistencias que dependen de lo que contengan estos envases. Hacer una buena elección de los mismos es fundamental para que su producto llegue a tiempo y en óptimas condiciones.Entrecor S.A fabrica cartones de cartón corrugado de ONDA SIMPLE, este tipo de cartón es el que tiene dos caras de cartón (liner) y un acanalado en el medio (onda). El 90% de los productos se transportan en cajas de este tipo.",
    image: recurso_33,
  },
  Cajas: {
    title: "Cajas de Cartón",
    text: "Las cajas de cartón corrugado pueden adecuarse al producto que contienen, tanto en su material como imprimiéndose o troquelándose. También se adaptan al transporte y al almacenamiento que quiera realizarse de las mismas. Existen distintas clases de cajas que podemos clasificarlas en:",
    buttons: [
      "Cajas con Aletas Divicajas",
      "Tapa y Fondo",
      "Wrap around",
      "Fondos P84",
    ],
    images: {
      "Cajas con Aletas Divicajas": recurso_36,
      "Tapa y Fondo": recurso_37,
    },
    sections: {
      "Wrap around": {
        title: "Wrap around",
        text: "El sistema wrap around es una tecnología de embalaje de cartón que se pliega alrededor de la matriz de productos cerrándose lateral o superiormente. A partir de láminas de cartón en pila, pudiendo utilizar cartón más delgado en wrap around.",
        images: [wrapAround1, wrapAround2],
      },
      "Fondos P84": {
        title: "Fondos P84",
        text: "Fondos de cartón corrugado desarrolladas para los mercados frutícola, bovino, avícola y otras industrias. Fabricadas en múltiples medidas y configuraciones, se adaptan al peso, formato y requisitos específicos de cada producto, garantizando protección, resistencia y eficiencia logística.",
        images: [fondosP841, fondosP842, fondosP843],
      },
    },
  },
  Accesorios: {
    title: "Accesorios",
    sections: [
      {
        name: "Separadores",
        image: recurso_38,
        description:
          "Son complementos de determinados tipos de cajas, cuyos productos por su fragilidad u otro motivo en particular, deben embalarse estando separados. Los mismos pueden tener distinta cantidad de espacios o celdas por ejemplo: Para 4 productos, para 6 productos, para 12, etc.",
      },
      {
        name: "Esquineros",
        image: recurso_39,
        description:
          "Son un refuerzo de cartón corrugado que se coloca en las esquinas del palletizado, para brindarle mayor estabilidad al mismo.",
      },
      {
        name: "Planchas Interpallets",
        image: recurso_40,
        description:
          "Son planchas de cartón corrugado, cuya función es separar el pallet del producto embalado para evitar el roce y a su vez el deterioro del mismo si ésta no estuviere.",
      },
      {
        name: "Cerco",
        image: recurso_41,
        description:
          "Los cercos son un refuerzo perimetral. Se puede usar tanto interior como exteriormente en las cajas.",
      },
    ],
  },
};

export default Productos;
